import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { RepairCodeExclusionSearchComponent } from '../../components/repair-code-exclusion/repair-code-exclusion-search/repair-code-exclusion-search.component';
import { RepairCodeExclusionGridComponent } from '../../components/repair-code-exclusion/repair-code-exclusion-grid/repair-code-exclusion-grid.component';
import { RepairCodeExclusionFiltersComponent } from '../../components/repair-code-exclusion/repair-code-exclusion-filters/repair-code-exclusion-filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NavigationStart, Router, RouterLink, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RepairCodeExclusionFilterForm } from '../../form-model/repair-code-exclusion-filter.form.model';
import { RepairCodeExclusionSearchTextForm } from '../../form-model/repair-code-exclusion-search-text.form.model';
import { RepairCodeExclusionService } from '../../services/repair-code-exclusion.service';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-repair-code-exclusion-list',
  templateUrl: './repair-code-exclusion.component.html',
  styleUrls: ['./repair-code-exclusion.component.scss'],
  imports: [
    RepairCodeExclusionSearchComponent,
    RouterLink,
    RouterModule,
    RepairCodeExclusionGridComponent,
    RepairCodeExclusionFiltersComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairCodeExclusionListComponent implements OnInit, OnDestroy {
  filterFormGroup = this.formBuilder.group({
    filterForm: this.formBuilder.group<RepairCodeExclusionFilterForm>({} as RepairCodeExclusionFilterForm),
    searchTextForm: this.formBuilder.group<RepairCodeExclusionSearchTextForm>({} as RepairCodeExclusionSearchTextForm),
  });

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly service: RepairCodeExclusionService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!event.url.startsWith('/master-data/repair-code-exclusion')) {
          this.service.setFilterFormValue(null);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
